import { useWindowDimensions } from 'react-native';

const DESKTOP_BREAKPOINT = 1024;

export const useIsLargeScreen = (): boolean => {
	const { width } = useWindowDimensions();
	return width >= DESKTOP_BREAKPOINT;
};
